(function(){
  'use strict';

  /* jr-homepage-safe-2.liquid · jr-homepage-safe-2-runtime-3 */
(function(){
var gh=document.getElementById('gh');
var heroPin=document.querySelector('#s-hero.pin');
var slides=document.querySelector('#s-hero .hero__slides');
var areas=document.querySelector('#s-hero .areas');
var cue=document.querySelector('#s-hero .cue');
function onScroll(){
var y=window.scrollY,vh=window.innerHeight;
if(y<vh){
if(slides) slides.style.setProperty('transform','translateY('+(y*0.14)+'px)','important');
if(areas){areas.style.setProperty('transform','translateY('+(y*-0.10)+'px)','important');areas.style.opacity=Math.max(0,1-(y/vh)*1.3);}
if(cue) cue.style.opacity=Math.max(0,1-(y/vh)*2.4);
}
document.querySelectorAll('[data-par]').forEach(function(el){
var r=el.getBoundingClientRect();var off=(r.top+r.height/2)-vh/2;var f=parseFloat(el.dataset.par)||0.12;
el.style.setProperty('transform','translateY('+(off*-f)+'px)','important');
});
}
window.addEventListener('scroll',onScroll,{passive:true});onScroll();
var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.08});
document.querySelectorAll('.rv').forEach(function(el){io.observe(el);});
var areaLinks=document.querySelectorAll('#s-hero .areas a');
if(areaLinks.length>1){var ai=0;setInterval(function(){areaLinks[ai].classList.remove('on');ai=(ai+1)%areaLinks.length;areaLinks[ai].classList.add('on');},7000);}
})();
;

  /* jr-homepage-safe-2.liquid · jr-homepage-safe-2-runtime-4 */
try{
(function(){
var strip=document.getElementById('strip__strip');
var bgs={};[].forEach.call(strip.querySelectorAll('.strip__bg'),function(b){bgs[b.dataset.key]=b;});
function show(key){for(var k in bgs)bgs[k].classList.toggle('is-on',k===key);}
[].forEach.call(strip.querySelectorAll('.col'),function(c){
c.addEventListener('mouseenter',function(){show(c.dataset.bg);});
});
strip.addEventListener('mouseleave',function(){show('default');});
})();
}catch(e){console.warn('strip',e);}
try{
(function(){
var ba=document.getElementById('concierge__ba'),dragging=false;
function setPos(x){var r=ba.getBoundingClientRect();var p=(x-r.left)/r.width;p=Math.max(0,Math.min(1,p));ba.style.setProperty('--p',p);}
function down(e){dragging=true;setPos((e.touches?e.touches[0]:e).clientX);}
function move(e){if(!dragging)return;setPos((e.touches?e.touches[0]:e).clientX);}
function up(){dragging=false;}
ba.addEventListener('mousedown',down);window.addEventListener('mousemove',move);window.addEventListener('mouseup',up);
ba.addEventListener('touchstart',down,{passive:true});window.addEventListener('touchmove',move,{passive:true});window.addEventListener('touchend',up);
})();
}catch(e){console.warn('concierge',e);}
try{
var data=[{"q": "Working with Jasjeet was honestly one of the BEST CHOICES we made while buying our home! He took care of everything like booking showings, explaining the paperwork, and negotiating for us. The whole process felt organized and stress-free.", "a": "Thisisour Home · Google Review · 5 stars"}, {"q": "Excellent abilities to go far above expectations with customized solutions to meet my needs. Jasjeet is some to rely on at all times.", "a": "Tim Aroge · Google Review · 5 stars"}, {"q": "I highly recommend Jasjeet Singh. He’s reliable, honest and operates with integrity. His work quality is consistently outstanding, exceeding my expectations every time.", "a": "Olajide Seun · Google Review · 5 stars"}, {"q": "We had a fantastic experience working with our realtor, Jasjeet Singh. He was helpful, competent, and committed to finding us the ideal house. He brought ease and smoothness to the entire process.", "a": "Martha Chukwunaru · Google Review · 5 stars"}, {"q": "Jasjeet gave my family and I a top notch and seamless experience in the purchase of our new home. Thank you so much for all you have done for us even when everything seemed impossible.", "a": "Lade Oyenuga · Google Review · 5 stars"}, {"q": "Jasjeet was great to work with. Always available, quick responses, and very knowledgeable. Buying our dream home was a great experience, and we would highly recommend him to anyone looking to buy.", "a": "Feven Yehdego · Google Review · 5 stars"}, {"q": "He is very professional, transparent and helpful. Even after the deal is done, his effort to reach back to the client proves that he is a clean heart personality. I would highly recommend him.", "a": "Shrutika Shripat · Google Review · 5 stars"}, {"q": "Jasjeet made it a seamless experience from start to finish. He was absolutely wonderful to work with, set realistic expectations, and helped us get an investment property after just 2 days of searching.", "a": "Hamza Ansari · Google Review · 5 stars"}, {"q": "He went above and beyond to sell our home and got us the full list price. From the beginning he was very helpful, right there for us daily, and treated us like VIP clients.", "a": "Elisee Kagbara · Google Review · 5 stars"}, {"q": "The entire deal was smooth, trouble free and timely because of his hard working efforts. We will always recommend him to new home buyers in Calgary since he is an honest licensed realtor.", "a": "Harneet Kaur Anand · Google Review · 5 stars"}, {"q": "Jasjeet had great communication skills during the search. He’s always been on top of things, especially through inspection and closing. He listens and works to make the purchase simple and successful.", "a": "sarvpreet kaur · Google Review · 5 stars"}, {"q": "Looking to buy or sell a home? Jesse is an enthusiastic realtor. He will find you what you want, he listens and works hard to make your dreams come true.", "a": "HELEN WILLERTON · Google Review · 5 stars"}, {"q": "Jasjeet is very professional, hard working and punctual. Made my home buying experience very smooth and friendly. I would highly recommend everyone to use his services.", "a": "seema ghumman · Google Review · 5 stars"}, {"q": "Mr. Jasjeet is a reliable, knowledgeable, and fantastic realtor to work with. He is extremely responsive and goes above and beyond to make the process stress free and timely.", "a": "Narayan Pokhrel · Google Review · 5 stars"}, {"q": "Jasjeet was professional, knowledgeable, charismatic and true to his words and work. From the beginning of selling our property and buying our second home, he was there every step of the way.", "a": "Nafas Ehsani · Google Review · 5 stars"}, {"q": "Thank you so much for your help with buying the property. You made the process simple and easy to understand, and we appreciated your patience and expertise.", "a": "Karthiga Pathmaharan · Google Review · 5 stars"}, {"q": "Coming from out of town, we put ourselves totally in his hands and were not disappointed. We were guided through the buying process from start to finish and were totally impressed.", "a": "Paul D C · Google Review · 5 stars"}];
var i=0,quote=document.getElementById('testimonials__quote'),author=document.getElementById('testimonials__author');
function render(n){
quote.classList.add('fade');author.classList.add('fade');
setTimeout(function(){
i=(n+data.length)%data.length;
quote.textContent=data[i].q;author.textContent=data[i].a;
quote.classList.remove('fade');author.classList.remove('fade');
},340);
}
document.getElementById('testimonials__next').addEventListener('click',function(){render(i+1);});
document.getElementById('testimonials__prev').addEventListener('click',function(){render(i-1);});
setInterval(function(){render(i+1);},8000);
}catch(e){console.warn('testimonials',e);}
;

  /* jr-homepage-safe-2.liquid · jr-homepage-safe-2-runtime-5 */
if(location.search.indexOf("contact_posted=true")>-1){var b=document.createElement("div");b.textContent="✓ Thank you, your message was sent. Jasjeet will be in touch shortly.";b.style.cssText="position:fixed;left:0;right:0;top:0;z-index:99999;background:#cf1235;color:#fff;padding:14px 16px;text-align:center;font:600 15px/1.3 system-ui,sans-serif";document.body.appendChild(b);window.scrollTo(0,0);setTimeout(function(){b.style.transition="opacity .6s";b.style.opacity="0"},6000);}
;

  /* jr-homepage-safe-2.liquid · jr-homepage-safe-2-runtime-6 */
(function(){
var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var design = !!(window.Shopify && window.Shopify.designMode);
var forceNativeScroll = true;
if (design) { document.documentElement.classList.remove('lenis','lenis-smooth'); document.body.classList.remove('lenis','lenis-smooth'); }
var pbg = [].slice.call(document.querySelectorAll('[data-parbg]'));
function bgParallax(){
if(reduce) return;
var vh = window.innerHeight;
for(var i=0;i<pbg.length;i++){
var el = pbg[i], host = el.parentElement;
var r = host.getBoundingClientRect();
if(r.bottom < -120 || r.top > vh + 120) continue;
var sp = parseFloat(el.getAttribute('data-parbg')) || 0.15;
var progress = ((r.top + r.height/2) - vh/2) / vh;
el.style.setProperty('transform','translate3d(0,' + (progress * sp * 100) + 'px,0)','important');
}
}
var toTop = document.querySelector('#s-footer .totop');
if(toTop){
toTop.setAttribute('onclick','');
toTop.addEventListener('click', function(){
if(window.__lenis){ window.__lenis.scrollTo(0); }
else { window.scrollTo({top:0, behavior:'smooth'}); }
});
}
function boot(){
bgParallax();
if(forceNativeScroll || reduce || design || typeof Lenis === 'undefined'){
window.addEventListener('scroll', bgParallax, {passive:true});
return;
}
var lenis = new Lenis({
duration: 1.1,
smoothWheel: true,
easing: function(t){ return Math.min(1, 1.001 - Math.pow(2, -10 * t)); }
});
window.__lenis = lenis;
lenis.on('scroll', bgParallax);
function raf(time){ lenis.raf(time); requestAnimationFrame(raf); }
requestAnimationFrame(raf);
}
if(forceNativeScroll || reduce || design){ boot(); }
else {
var s = document.createElement('script');
s.src = 'https://cdn.jsdelivr.net/npm/lenis@1.1.13/dist/lenis.min.js';
s.onload = boot; s.onerror = boot;
document.head.appendChild(s);
}
window.addEventListener('resize', bgParallax, {passive:true});
})();
(function(){
var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var cards = [].slice.call(document.querySelectorAll('#s-media .press-card'));
if(!cards.length) return;
function showAll(){ cards.forEach(function(c){ c.classList.add('pc-in'); }); }
if(reduce || !('IntersectionObserver' in window)){ showAll(); return; }
var io = new IntersectionObserver(function(entries){
entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('pc-in'); io.unobserve(e.target); } });
}, {rootMargin:'0px 0px -8% 0px', threshold:0.15});
cards.forEach(function(c){ io.observe(c); });
window.addEventListener('load', function(){ setTimeout(showAll, 1400); });
})();
(function(){
var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var items = [].slice.call(document.querySelectorAll('[data-rise]'));
if(!items.length) return;
[].forEach.call(document.querySelectorAll('[data-rise-group]'), function(group){
var kids = group.querySelectorAll('[data-rise]');
for(var i=0;i<kids.length;i++){ kids[i].style.setProperty('--rise-d', (i*80)+'ms'); }
});
function showAll(){ items.forEach(function(el){ el.classList.add('rise-in'); }); }
if(reduce || !('IntersectionObserver' in window)){ showAll(); return; }
var io = new IntersectionObserver(function(entries){
entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('rise-in'); io.unobserve(e.target); } });
}, {rootMargin:'0px 0px -12% 0px', threshold:0.12});
items.forEach(function(el){ io.observe(el); });
/* jr-rise-fix 12aug2026: removed unconditional 2s force-reveal so IntersectionObserver-driven scroll reveal actually plays. Reduced-motion/no-IO browsers already handled above via showAll(); return; */
})();
(function(){
var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var titleDrifts = [].slice.call(document.querySelectorAll('[data-drift]:not(img)'));
var decorativeDrifts = [].slice.call(document.querySelectorAll('img[data-drift]'));
var verticalTitles = [].slice.call(document.querySelectorAll('[data-title-vertical]'));
if((!titleDrifts.length && !decorativeDrifts.length && !verticalTitles.length) || reduce) return;
var ticking = false;
var DESKTOP_TITLE_DRIFT = 120;
var MOBILE_TITLE_DRIFT = 60;
function sharedTitleDrift(){
return (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) ? MOBILE_TITLE_DRIFT : DESKTOP_TITLE_DRIFT;
}
function directionFrom(value){
var parsed = parseFloat(value);
if(!isFinite(parsed) || parsed === 0) return 1;
return parsed < 0 ? -1 : 1;
}
function titleAmountFrom(el, shared){
var raw = parseFloat(el.getAttribute('data-drift'));
if(isFinite(raw) && Math.abs(raw) > 1) return raw;
return shared * directionFrom(el.getAttribute('data-drift'));
}
function progressFor(rect, vh){
return ((rect.top + rect.height / 2) - vh / 2) / vh;
}
function applyX(el, rect, vh, amount){
var p = progressFor(rect, vh);
el.style.setProperty('transform','translate3d(' + (p * amount).toFixed(1) + 'px,0,0)','important');
}
function applyY(el, rect, vh, amount){
var p = progressFor(rect, vh);
el.style.setProperty('transform','translate3d(0,' + (p * amount).toFixed(1) + 'px,0)','important');
}
function update(){
var vh = window.innerHeight;
var shared = sharedTitleDrift();
for(var i=0;i<titleDrifts.length;i++){
var el = titleDrifts[i], r = el.getBoundingClientRect();
if(r.bottom < -300 || r.top > vh + 300) continue;
applyX(el, r, vh, titleAmountFrom(el, shared));
}
for(var d=0;d<decorativeDrifts.length;d++){
var de = decorativeDrifts[d], dr = de.getBoundingClientRect();
if(dr.bottom < -300 || dr.top > vh + 300) continue;
var rawDecor = parseFloat(de.getAttribute('data-drift')) || 0;
applyX(de, dr, vh, rawDecor);
}
for(var j=0;j<verticalTitles.length;j++){
var vt = verticalTitles[j], vr = vt.getBoundingClientRect();
if(vr.bottom < -300 || vr.top > vh + 300) continue;
applyY(vt, vr, vh, shared * directionFrom(vt.getAttribute('data-title-vertical')));
}
ticking = false;
}
function onScroll(){ if(!ticking){ window.requestAnimationFrame(update); ticking = true; } }
window.addEventListener('scroll', onScroll, {passive:true});
window.addEventListener('resize', onScroll, {passive:true});
window.addEventListener('load', update);
update();
})();
;

  /* jr-homepage-safe-2.liquid · jr-ogroup-mobile-carousel */
(function(){
function qs(sel,ctx){return (ctx||document).querySelector(sel);}
function qsa(sel,ctx){return Array.prototype.slice.call((ctx||document).querySelectorAll(sel));}
function enableRailAutoScroll(railSel,itemSel){
var rail=qs(railSel); if(!rail || rail.dataset.mobileRailBound==='true') return;
rail.dataset.mobileRailBound='true';
var paused=false, index=0;
function active(){return window.matchMedia && window.matchMedia('(max-width:989px)').matches && rail.scrollWidth>rail.clientWidth+20;}
function items(){return qsa(itemSel,rail);}
function go(){
if(!active()||paused) return;
var it=items(); if(it.length<2) return;
index=(index+1)%it.length;
rail.scrollTo({left:it[index].offsetLeft-parseFloat(getComputedStyle(rail).paddingLeft||0),behavior:'smooth'});
}
['touchstart','pointerdown','mouseenter','focusin'].forEach(function(e){rail.addEventListener(e,function(){paused=true;},{passive:true});});
['touchend','pointerup','mouseleave','focusout'].forEach(function(e){rail.addEventListener(e,function(){setTimeout(function(){paused=false;},2400);},{passive:true});});
setInterval(go,4800);
}
function init(){
enableRailAutoScroll('#s-listings .grid','#s-listings .card');
enableRailAutoScroll('#s-media .media__grid','#s-media .press-card');
}
if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
})();
;

  /* jr-homepage-safe-2.liquid · jr-scroll-first-half-counters-v72 */
(function(){
'use strict';
var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var rafWhy = null;
var rafPrices = null;
var scrollRaf = null;
var whyDone = false;
var pricesDone = false;
var started = false;
var whyStart = 0;
function qsa(sel, root){ return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
function clamp(n,min,max){ return Math.max(min, Math.min(max, n)); }
function fmtPlain(n){ return Math.round(n).toLocaleString('en-US'); }
function fmtMoney(v){
v = Math.max(0, Math.round(v));
if(v >= 1000000){
var m = Math.round(v / 10000) / 100;
return '$' + String(m).replace(/\.00$/, '').replace(/\.0$/, '') + 'M';
}
return '$' + Math.round(v / 1000) + 'K';
}
function getTarget(el, attr){
var raw = (el && el.getAttribute(attr || 'data-target')) || '0';
raw = String(raw).replace(/,/g,'');
return parseFloat(raw) || 0;
}
function isVisibleFirstHalf(section){
if(!section) return false;
var r = section.getBoundingClientRect();
var vh = window.innerHeight || document.documentElement.clientHeight || 1;
var h = r.height || section.offsetHeight || 1;
return r.bottom > 0 && r.top < vh && r.top > -(h * 0.5);
}
function isPastHalf(section){
if(!section) return false;
var r = section.getBoundingClientRect();
var h = r.height || section.offsetHeight || 1;
return r.top <= -(h * 0.5);
}
function firstHalfProgress(section){
if(!section) return 0;
var r = section.getBoundingClientRect();
var vh = window.innerHeight || document.documentElement.clientHeight || 1;
var h = r.height || section.offsetHeight || 1;
return clamp((vh - r.top) / (vh + h * 0.5), 0, 1);
}
function easeOutCubic(t){ t = clamp(t,0,1); return 1 - Math.pow(1 - t, 3); }
function renderWhyValue(el, value){
if(!el) return;
var pre = el.getAttribute('data-pre') || '';
var suf = el.getAttribute('data-suf') || '';
el.innerHTML = '<span class="pre">' + pre + '</span><span class="num">' + fmtPlain(value) + '</span><span class="suf">' + suf + '</span>';
var stat = el.closest && el.closest('.stat');
if(stat) stat.classList.add('is-counting');
}
function setWhyFinal(){
qsa('#s-why .stat__v').forEach(function(el){ renderWhyValue(el, getTarget(el, 'data-target')); });
whyDone = true;
}
function resetWhyZero(){
if(whyDone) return;
qsa('#s-why .stat__v').forEach(function(el){ renderWhyValue(el, 0); });
}
function animateWhy(now){
if(whyDone) return;
var section = document.getElementById('s-why');
if(!section) return;
if(isPastHalf(section) || reduce){ setWhyFinal(); return; }
if(!isVisibleFirstHalf(section)) return;
if(!whyStart) whyStart = now;
var prog = clamp((now - whyStart) / 1400, 0, 1);
var eased = easeOutCubic(prog);
qsa('#s-why .stat__v').forEach(function(el){
renderWhyValue(el, getTarget(el, 'data-target') * eased);
});
if(prog >= 1) setWhyFinal();
}
function whyHasWork(){
var why = document.getElementById('s-why');
return why && !whyDone && isVisibleFirstHalf(why);
}
function tickWhy(now){
rafWhy = null;
animateWhy(now || performance.now());
if(whyHasWork()) rafWhy = window.requestAnimationFrame(tickWhy);
}
function startWhyLoop(){
if(rafWhy || whyDone) return;
rafWhy = window.requestAnimationFrame(tickWhy);
}
function setBarVisual(bar, progress, finalMode){
var val = getTarget(bar, 'data-val');
var fill = bar.querySelector('.bar__fill');
var num = bar.querySelector('.bar__num');
var parent = bar.parentNode;
var bars = parent ? qsa('.bar', parent) : qsa('#s-prices .bar');
var max = Math.max.apply(null, bars.map(function(b){ return getTarget(b, 'data-val'); })) || 1;
var finalPct = clamp(val / max, 0, 1);
var eased = finalMode ? 1 : easeOutCubic(progress);
var liveVal = finalMode ? val : val * eased;
var liveScale = finalMode ? finalPct : finalPct * eased;
if(num) num.textContent = fmtMoney(liveVal);
if(fill){
fill.style.setProperty('--jr-price-scale', String(clamp(liveScale,0,1)));
fill.style.setProperty('height', '100%', 'important');
}
}
function resetPricesZero(){
if(pricesDone) return;
var section = document.getElementById('s-prices');
if(section) section.classList.remove('is-price-final');
qsa('#s-prices .bar').forEach(function(bar){
var num = bar.querySelector('.bar__num');
var fill = bar.querySelector('.bar__fill');
if(num) num.textContent = '$0';
if(fill){
fill.style.setProperty('--jr-price-scale', '0');
fill.style.setProperty('height', '100%', 'important');
}
});
}
function setPricesFinal(){
var section = document.getElementById('s-prices');
qsa('#s-prices .bar').forEach(function(bar){ setBarVisual(bar, 1, true); });
if(section) section.classList.add('is-price-final');
pricesDone = true;
}
function pricesMidpointReached(section){
if(!section) return false;
var r = section.getBoundingClientRect();
var vh = window.innerHeight || document.documentElement.clientHeight || 1;
var viewportMid = vh * 0.5;
var sectionMid = r.top + ((r.height || section.offsetHeight || 1) * 0.5);
return viewportMid >= sectionMid;
}
function pricesFirstHalfProgress(section){
if(!section) return 0;
var r = section.getBoundingClientRect();
var vh = window.innerHeight || document.documentElement.clientHeight || 1;
var h = r.height || section.offsetHeight || 1;
var startTop = vh;
var stopTop = (vh * 0.5) - (h * 0.5);
return clamp((startTop - r.top) / Math.max(1, startTop - stopTop), 0, 1);
}
function pricesHasWork(){
var section = document.getElementById('s-prices');
return section && !pricesDone && isVisibleFirstHalf(section) && !pricesMidpointReached(section);
}
function animatePrices(now){
if(pricesDone) return;
var section = document.getElementById('s-prices');
if(!section) return;
if(reduce || pricesMidpointReached(section)){ setPricesFinal(); return; }
if(!isVisibleFirstHalf(section)) return;
var scrollP = pricesFirstHalfProgress(section);
qsa('#s-prices .bar').forEach(function(bar, i){
var cycle = ((now / 1350) + (i * 0.075)) % 1;
var pulse = easeOutCubic(cycle);
var visibleP = Math.max(scrollP * 0.82, pulse);
setBarVisual(bar, visibleP, false);
});
}
function tickPrices(now){
rafPrices = null;
animatePrices(now || performance.now());
if(pricesHasWork()) rafPrices = window.requestAnimationFrame(tickPrices);
}
function startPricesLoop(){
if(rafPrices || pricesDone) return;
rafPrices = window.requestAnimationFrame(tickPrices);
}
function checkNow(){
var why = document.getElementById('s-why');
var prices = document.getElementById('s-prices');
if(why && !whyDone && isPastHalf(why)) setWhyFinal();
if(prices && !pricesDone && pricesMidpointReached(prices)) setPricesFinal();
if(why && !whyDone && isVisibleFirstHalf(why)) startWhyLoop();
if(prices && !pricesDone && isVisibleFirstHalf(prices)) startPricesLoop();
}
function requestScrollUpdate(){
if(scrollRaf) return;
scrollRaf = window.requestAnimationFrame(function(){
scrollRaf = null;
checkNow();
});
}
function init(){
if(started) return;
started = true;
resetWhyZero();
resetPricesZero();
['scroll','resize','orientationchange'].forEach(function(evt){
window.addEventListener(evt, requestScrollUpdate, {passive:true});
});
window.addEventListener('load', requestScrollUpdate, {once:true});
requestScrollUpdate();
}
if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
document.addEventListener('shopify:section:load', function(){
if(rafWhy) window.cancelAnimationFrame(rafWhy);
if(rafPrices) window.cancelAnimationFrame(rafPrices);
if(scrollRaf) window.cancelAnimationFrame(scrollRaf);
rafWhy = null; rafPrices = null; scrollRaf = null; started = false; whyDone = false; pricesDone = false; init();
});
})();
;

  /* jr-homepage-safe-2.liquid · jr-possession-day-carousel */
(function(){
function initCarousel(root){
if(!root || root.dataset.bound === 'true') return;
var slides = Array.prototype.slice.call(root.querySelectorAll('[data-possession-slide]'));
var dots = Array.prototype.slice.call(root.querySelectorAll('[data-possession-dot]'));
if(slides.length < 2) return;
root.dataset.bound = 'true';
var index = 0;
var paused = false;
var moving = false;
slides.forEach(function(slide, i){
slide.classList.toggle('is-active', i === 0);
slide.classList.toggle('is-ready', i !== 0);
slide.classList.remove('is-leaving');
});
function show(next){
if(moving) return;
var target = (next + slides.length) % slides.length;
if(target === index) return;
moving = true;
var current = slides[index];
var incoming = slides[target];
incoming.classList.remove('is-leaving');
incoming.classList.add('is-ready');
incoming.offsetHeight; // force browser to start incoming slide off-screen right
current.classList.remove('is-active');
current.classList.add('is-leaving');
incoming.classList.remove('is-ready');
incoming.classList.add('is-active');
dots.forEach(function(dot, i){ dot.classList.toggle('is-active', i === target); });
window.setTimeout(function(){
current.classList.remove('is-leaving');
current.classList.add('is-ready');
index = target;
moving = false;
}, 980);
}
dots.forEach(function(dot, i){
dot.addEventListener('click', function(){ show(i); }, { passive:true });
});
['mouseenter','focusin','touchstart','pointerdown'].forEach(function(evt){
root.addEventListener(evt, function(){ paused = true; }, { passive:true });
});
['mouseleave','focusout','touchend','pointerup'].forEach(function(evt){
root.addEventListener(evt, function(){ setTimeout(function(){ paused = false; }, 1800); }, { passive:true });
});
setInterval(function(){ if(!paused) show(index + 1); }, 4300);
}
function boot(){
Array.prototype.slice.call(document.querySelectorAll('[data-possession-carousel]')).forEach(initCarousel);
}
if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once:true }); else boot();
document.addEventListener('shopify:section:load', boot);
})();
;

  /* jr-homepage-safe-2.liquid · jr-possession-card-ratio-v67 */
(function(){
function ratioFor(img){
if(!img) return '1 / 1';
var w = img.naturalWidth || parseInt(img.getAttribute('width'),10) || 1;
var h = img.naturalHeight || parseInt(img.getAttribute('height'),10) || 1;
if(!w || !h) return '1 / 1';
return w + ' / ' + h;
}
function update(root){
if(!root) return;
var card = root.querySelector('.possession-card');
var active = root.querySelector('[data-possession-slide].is-active') || root.querySelector('[data-possession-slide]');
if(!card || !active) return;
var img = active.querySelector('.possession-img');
var apply = function(){ card.style.setProperty('--possession-active-ratio', ratioFor(img)); };
apply();
if(img && !img.complete){ img.addEventListener('load', apply, {once:true}); }
}
function bind(root){
if(!root || root.dataset.ratioBound === 'true') return;
root.dataset.ratioBound = 'true';
update(root);
var slides = root.querySelectorAll('[data-possession-slide]');
slides.forEach(function(slide){
var obs = new MutationObserver(function(){ update(root); });
obs.observe(slide, {attributes:true, attributeFilter:['class']});
var img = slide.querySelector('.possession-img');
if(img) img.addEventListener('load', function(){ update(root); });
});
window.addEventListener('resize', function(){ update(root); }, {passive:true});
}
function boot(){
Array.prototype.slice.call(document.querySelectorAll('[data-possession-carousel]')).forEach(bind);
}
if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once:true}); else boot();
document.addEventListener('shopify:section:load', boot);
})();
;

  /* jr-homepage-safe-3.liquid · jr-about-title-lines-drift-v121 */
(function(){
var sec=document.querySelector('#s-about .about');
var title=document.querySelector('#s-about .about__name.about__name--with-lines');
var mark=document.querySelector('#s-about .about__brush');
var lines=[].slice.call(document.querySelectorAll('#s-about .jr-og-about-line'));
var hline=document.querySelector('#s-about .jr-og-about-line--h');
if(!sec || !title || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
function clamp(n,a,b){return Math.max(a,Math.min(b,n));}
function isMobile(){return window.matchMedia && window.matchMedia('(max-width: 980px)').matches;}
var ticking=false;
var lastY=window.pageYOffset || document.documentElement.scrollTop || 0;
function applyGroup(x){
var v='translate3d('+x.toFixed(1)+'px,0,0)';
title.style.setProperty('transform',v,'important');
for(var i=0;i<lines.length;i++) lines[i].style.setProperty('transform',v,'important');
}
function update(){
ticking=false;
if(isMobile()){
title.style.setProperty('transform','none','important');
for(var i=0;i<lines.length;i++) lines[i].style.setProperty('transform','none','important');
if(hline) sec.style.setProperty('--jr-hline-extra','0px');
if(mark) mark.style.setProperty('transform','none','important');
return;
}
var y=window.pageYOffset || document.documentElement.scrollTop || 0;
var goingUp=y < lastY;
lastY=y;
var r=sec.getBoundingClientRect();
var vh=window.innerHeight || document.documentElement.clientHeight;
var p=clamp((vh - r.top) / (vh + r.height),0,1);
var groupX=88 - (p * 790);
applyGroup(groupX);
var extra=(p * 190) + (goingUp ? 70 : 0);
sec.style.setProperty('--jr-hline-extra',extra.toFixed(1)+'px');
if(mark){
var markX=135 - (p * 295);
mark.style.setProperty('transform','translate3d('+markX.toFixed(1)+'px,-50%,0)','important');
}
}
function request(){if(!ticking){ticking=true;requestAnimationFrame(update);}}
window.addEventListener('scroll',request,{passive:true});
window.addEventListener('resize',request);
window.addEventListener('load',update);
update();
})();
;

  /* jr-homepage-safe-3.liquid · jr-about-mobile-motion-v124 */
(function(){
var sec=document.querySelector('#s-about .about');
var title=document.querySelector('#s-about .about__name.about__name--with-lines');
var mark=document.querySelector('#s-about .about__brush');
var lines=[].slice.call(document.querySelectorAll('#s-about .jr-og-about-line'));
if(!sec || !title || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
function isMobile(){return window.matchMedia && window.matchMedia('(max-width: 980px)').matches;}
function clamp(n,a,b){return Math.max(a,Math.min(b,n));}
var ticking=false;
function update(){
ticking=false;
if(!isMobile()) return;
var r=sec.getBoundingClientRect();
var vh=window.innerHeight || document.documentElement.clientHeight;
var p=clamp((vh - r.top) / (vh + Math.max(r.height,1)),0,1);
var x=22 - (p * 52);
var tx='translate3d('+x.toFixed(1)+'px,0,0)';
title.style.setProperty('transform',tx,'important');
for(var i=0;i<lines.length;i++) lines[i].style.setProperty('transform',tx,'important');
sec.style.setProperty('--jr-mobile-hline-extra',(p*54).toFixed(1)+'px');
if(mark){
var mx=18 - (p * 42);
mark.style.setProperty('transform','translate3d('+mx.toFixed(1)+'px,0,0)','important');
}
}
function request(){if(!ticking){ticking=true;requestAnimationFrame(update);}}
window.addEventListener('scroll',request,{passive:true});
window.addEventListener('resize',request);
window.addEventListener('load',update);
update();
})();
;

  /* jr-homepage-safe-3.liquid · jr-about-mobile-drift-match-v125 */
(function(){
var sec=document.querySelector('#s-about .about');
var title=document.querySelector('#s-about .about__name.about__name--with-lines');
var mark=document.querySelector('#s-about .about__brush');
var lines=[].slice.call(document.querySelectorAll('#s-about .jr-og-about-line'));
if(!sec || !title || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
function isMobile(){return window.matchMedia && window.matchMedia('(max-width: 980px)').matches;}
function progressFor(rect, vh){return ((rect.top + rect.height / 2) - vh / 2) / vh;}
function clamp(n,a,b){return Math.max(a,Math.min(b,n));}
var ticking=false;
function update(){
ticking=false;
if(!isMobile()) return;
var vh=window.innerHeight || document.documentElement.clientHeight;
var tr=title.getBoundingClientRect();
var titleP=progressFor(tr,vh);
var titleX=titleP * -240;
var titleTransform='translate3d('+titleX.toFixed(1)+'px,0,0)';
title.style.setProperty('transform',titleTransform,'important');
for(var i=0;i<lines.length;i++){
lines[i].style.setProperty('transform',titleTransform,'important');
}
var lineExtra=clamp(Math.abs(titleP) * 90,0,90);
sec.style.setProperty('--jr-mobile-hline-extra',lineExtra.toFixed(1)+'px');
if(mark){
var mr=mark.getBoundingClientRect();
var markAmount=parseFloat(mark.getAttribute('data-drift'));
if(!isFinite(markAmount)) markAmount=240;
var markX=progressFor(mr,vh) * markAmount;
mark.style.setProperty('transform','translate3d('+markX.toFixed(1)+'px,0,0)','important');
}
}
function request(){if(!ticking){ticking=true;requestAnimationFrame(update);}}
window.addEventListener('scroll',request,{passive:true});
window.addEventListener('resize',request);
window.addEventListener('orientationchange',request);
window.addEventListener('load',update);
update();
})();
;

})();


/* ============================================================================
   JR-HERO-0902 :: homepage hero Price / Filters dropdown panels.
   Renders the full option set (all residential property types, every bed /
   bath / size step) into the two panels in the hero bar and writes the choices
   into the hidden inputs the hero submit handler already reads.
   Only filters the BoldTrail/Worker layer actually supports are offered.
   ========================================================================== */
(function(){
  var CSS = ""
  + "#s-hero .jrhx__sep{flex:0 0 auto!important;display:block!important;width:1px!important;height:26px!important;align-self:center!important;background:rgba(244,239,231,.22)!important;margin:0 4px!important}"
  + "#s-hero .jrhx{position:relative!important;flex:0 0 auto!important;display:flex!important;align-items:center!important}"
  + "#s-hero .jrhx__t{display:inline-flex!important;align-items:center!important;gap:8px!important;height:44px!important;padding:0 16px!important;border:0!important;background:none!important;color:rgba(244,239,231,.92)!important;font-family:'Sofia Sans','Helvetica Neue',Arial,sans-serif!important;font-size:14.5px!important;font-weight:500!important;white-space:nowrap!important;cursor:pointer!important}"
  + "#s-hero .jrhx__t:hover,#s-hero .jrhx.is-on .jrhx__t{color:#fff!important}"
  + "#s-hero .jrhx__i{font-size:16px!important;font-weight:600!important;color:rgba(244,239,231,.6)!important;line-height:1!important}"
  + "#s-hero .jrhx.is-on .jrhx__i{color:#CF1235!important}"
  + "#s-hero .jrhx__p{position:absolute!important;bottom:calc(100% + 14px)!important;right:0!important;z-index:140!important;width:400px!important;max-height:min(66vh,520px)!important;overflow-y:auto!important;padding:24px!important;border:1px solid rgba(244,239,231,.16)!important;border-radius:14px!important;background:rgba(16,15,14,.98)!important;backdrop-filter:blur(18px)!important;box-shadow:0 30px 70px rgba(0,0,0,.6)!important;box-sizing:border-box!important;text-align:left!important}"
  + "#s-hero .jrhx__p[hidden]{display:none!important}"
  + "#s-hero .jrhx__p--w{width:600px!important}"
  + "#s-hero .jrhx__h{margin:0 0 12px!important;font-family:'Sofia Sans','Helvetica Neue',Arial,sans-serif!important;font-size:10.5px!important;font-weight:700!important;letter-spacing:.18em!important;text-transform:uppercase!important;color:rgba(244,239,231,.5)!important}"
  + "#s-hero .jrhx__sec+.jrhx__sec{margin-top:22px!important;padding-top:20px!important;border-top:1px solid rgba(244,239,231,.12)!important}"
  + "#s-hero .jrhx__grid{display:grid!important;grid-template-columns:1fr 1fr!important;gap:9px 14px!important}"
  + "#s-hero .jrhx__pills{display:flex!important;flex-wrap:wrap!important;gap:8px!important}"
  + "#s-hero .jrhx__o{display:flex!important;align-items:center!important;gap:9px!important;min-height:34px!important;font-family:'Sofia Sans','Helvetica Neue',Arial,sans-serif!important;font-size:14.5px!important;font-weight:500!important;color:rgba(244,239,231,.9)!important;cursor:pointer!important;-webkit-user-select:none!important;user-select:none!important}"
  + "#s-hero .jrhx__o input{width:16px!important;height:16px!important;margin:0!important;accent-color:#CF1235!important;cursor:pointer!important;flex:0 0 auto!important}"
  + "#s-hero .jrhx__b{display:inline-flex!important;align-items:center!important;justify-content:center!important;min-width:52px!important;height:38px!important;padding:0 15px!important;border:1px solid rgba(244,239,231,.2)!important;border-radius:9px!important;background:rgba(244,239,231,.05)!important;color:rgba(244,239,231,.88)!important;font-family:'Sofia Sans','Helvetica Neue',Arial,sans-serif!important;font-size:14px!important;font-weight:600!important;cursor:pointer!important;transition:border-color .13s,background .13s,color .13s!important}"
  + "#s-hero .jrhx__b:hover{border-color:rgba(244,239,231,.42)!important}"
  + "#s-hero .jrhx__b.on{border-color:#CF1235!important;background:rgba(207,18,53,.24)!important;color:#fff!important}"
  + "#s-hero .jrhx__act{display:flex!important;align-items:center!important;justify-content:space-between!important;gap:12px!important;margin-top:22px!important;padding-top:18px!important;border-top:1px solid rgba(244,239,231,.12)!important}"
  + "#s-hero .jrhx__clr{border:0!important;background:none!important;padding:0!important;color:rgba(244,239,231,.6)!important;font-family:'Sofia Sans','Helvetica Neue',Arial,sans-serif!important;font-size:12.5px!important;letter-spacing:.08em!important;text-transform:uppercase!important;cursor:pointer!important}"
  + "#s-hero .jrhx__clr:hover{color:#fff!important}"
  + "#s-hero .jrhx__done{height:40px!important;padding:0 26px!important;border:0!important;border-radius:9px!important;background:#CF1235!important;color:#fff!important;font-family:'Sofia Sans','Helvetica Neue',Arial,sans-serif!important;font-size:12.5px!important;font-weight:700!important;letter-spacing:.14em!important;text-transform:uppercase!important;cursor:pointer!important}"
  + "#s-hero .jrhx__done:hover{background:#a50f2b!important}"
  + "@media (max-width:900px){#s-hero .jrhx__t{padding:0 10px!important;font-size:13px!important}}"
  + "@media (max-width:700px){#s-hero .jrhx{position:static!important}#s-hero .jrhx__p,#s-hero .jrhx__p--w{left:0!important;right:0!important;width:auto!important;max-height:min(50vh,405px)!important;padding:18px!important}#s-hero .jrhx__pills .jrhx__b{width:auto!important;flex:0 0 auto!important;padding:0 13px!important}#s-hero .jrhx__grid{grid-template-columns:1fr!important}#s-hero .jrhx__t{padding:0 8px!important;font-size:12px!important;gap:5px!important}#s-hero .jrhx__sep{margin:0 1px!important}}#s-hero .hero-search__btn::after{display:none!important}";
  var st=document.getElementById('jrhx-css');
  if(!st){st=document.createElement('style');st.id='jrhx-css';st.textContent=CSS;document.head.appendChild(st);}

  var TYPES=[['','All Residential'],['detached','Houses / Detached'],['row-townhouse','Row / Townhomes'],['apartment','Condos & Apartments'],['full-duplex','Duplexes'],['multi-family','Multi-Family']];
  var PRICES=[100000,200000,300000,400000,500000,600000,700000,800000,1000000,1250000,1500000,2000000,3000000,5000000];
  var BEDS=[1,2,3,4,5,6];
  var BATHS=[1,2,3,4,5];
  var SQFT=[800,1000,1200,1500,2000,2500,3000];

  function money(n){ return n>=1000000 ? '$'+String(n/1000000).replace(/\.0$/,'')+'M' : '$'+(n/1000)+'K'; }
  function form(){ return document.querySelector('form.hero-search__panel'); }
  function hid(n){ var f=form(); return f?f.querySelector('input[type="hidden"][name="'+n+'"]'):null; }
  function val(n){ var e=hid(n); return e?e.value:''; }
  function set(n,v){ var e=hid(n); if(e)e.value=v; }

  function opts(name,list,fmt){
    return list.map(function(v){
      return '<button type="button" class="jrhx__b" data-f="'+name+'" data-v="'+v+'">'+(fmt?fmt(v):v+'+')+'</button>';
    }).join('');
  }
  function priceCol(name,label){
    return '<div class="jrhx__h">'+label+'</div><div class="jrhx__pills">'
      +'<button type="button" class="jrhx__b" data-f="'+name+'" data-v="">Any</button>'
      +opts(name,PRICES,money)+'</div>';
  }
  function buildPrice(){
    return '<div class="jrhx__sec">'+priceCol('pmin','Min Price')+'</div>'
      +'<div class="jrhx__sec">'+priceCol('pmax','Max Price')+'</div>'
      +'<div class="jrhx__act"><button type="button" class="jrhx__clr" data-clr="pmin,pmax">Clear</button><button type="button" class="jrhx__done">Done</button></div>';
  }
  function buildFilters(){
    return '<div class="jrhx__sec"><div class="jrhx__h">Property Type</div><div class="jrhx__grid">'
      + TYPES.map(function(t){return '<label class="jrhx__o"><input type="radio" name="jrhxtype" data-f="ptype" data-v="'+t[0]+'"><span>'+t[1]+'</span></label>';}).join('')
      + '</div></div>'
      + '<div class="jrhx__sec"><div class="jrhx__h">Bedrooms</div><div class="jrhx__pills"><button type="button" class="jrhx__b" data-f="pbeds" data-v="">Any</button>'+opts('pbeds',BEDS)+'</div></div>'
      + '<div class="jrhx__sec"><div class="jrhx__h">Bathrooms</div><div class="jrhx__pills"><button type="button" class="jrhx__b" data-f="pbaths" data-v="">Any</button>'+opts('pbaths',BATHS)+'</div></div>'
      + '<div class="jrhx__sec"><div class="jrhx__h">Minimum Size</div><div class="jrhx__pills"><button type="button" class="jrhx__b" data-f="psqft" data-v="">Any</button>'+opts('psqft',SQFT,function(v){return String(v).replace(/(\d)(?=(\d{3})+$)/g,'$1,')+'+ sq ft';})+'</div></div>'
      + '<div class="jrhx__sec"><div class="jrhx__h">Options</div><div class="jrhx__pills">'
      + '<button type="button" class="jrhx__b" data-f="poh" data-v="1" data-tog="1">Open House</button>'
      + '<button type="button" class="jrhx__b" data-f="pnc" data-v="1" data-tog="1">New Construction</button>'
      + '</div></div>'
      + '<div class="jrhx__act"><button type="button" class="jrhx__clr" data-clr="ptype,pbeds,pbaths,psqft,poh,pnc">Clear all</button><button type="button" class="jrhx__done">Done</button></div>';
  }
  function paint(){
    var f=form(); if(!f) return;
    [].forEach.call(f.querySelectorAll('.jrhx__b'),function(b){
      b.classList.toggle('on', val(b.getAttribute('data-f'))===b.getAttribute('data-v'));
    });
    [].forEach.call(f.querySelectorAll('.jrhx__o input'),function(i){
      i.checked = val(i.getAttribute('data-f'))===i.getAttribute('data-v');
    });
  }
  function fill(){
    var f=form(); if(!f) return false;
    var ps=f.querySelectorAll('.jrhx__p'); if(ps.length<2) return false;
    if(ps[0].getAttribute('data-built')) return true;
    ps[0].innerHTML=buildPrice(); ps[0].setAttribute('data-built','1');
    ps[1].innerHTML=buildFilters(); ps[1].setAttribute('data-built','1');
    paint(); return true;
  }
  function shut(){
    [].forEach.call(document.querySelectorAll('.jrhx'),function(x){
      var q=x.querySelector('.jrhx__p'); if(q)q.hidden=true;
      x.classList.remove('is-on');
      var t=x.querySelector('.jrhx__t'); if(t)t.setAttribute('aria-expanded','false');
    });
  }
  document.addEventListener('click',function(e){
    var el=e.target&&e.target.closest?e.target:null; if(!el){shut();return;}
    var t=el.closest('.jrhx__t');
    if(t){ e.preventDefault(); e.stopPropagation(); fill();
      var d=t.closest('.jrhx'), p=d.querySelector('.jrhx__p'), open=p.hidden;
      shut(); if(open){ p.hidden=false; d.classList.add('is-on'); t.setAttribute('aria-expanded','true'); jrhxFit(p); paint(); }
      return; }
    var b=el.closest('.jrhx__b');
    if(b){ e.preventDefault(); e.stopPropagation();
      var n=b.getAttribute('data-f'), v=b.getAttribute('data-v');
      if(b.getAttribute('data-tog')) set(n, val(n)==='1' ? '' : '1'); else set(n,v);
      paint(); return; }
    var o=el.closest('.jrhx__o');
    if(o){ var i=o.querySelector('input'); if(i){ set(i.getAttribute('data-f'), i.getAttribute('data-v')); setTimeout(paint,0); } e.stopPropagation(); return; }
    var c=el.closest('.jrhx__clr');
    if(c){ e.preventDefault(); e.stopPropagation(); c.getAttribute('data-clr').split(',').forEach(function(n){set(n,'');}); paint(); return; }
    if(el.closest('.jrhx__done')){ e.preventDefault(); e.stopPropagation(); shut(); return; }
    if(el.closest('.jrhx__p')) return;
    shut();
  },true);
  function jrhxFit(p){ try{ var hb=0,hh=document.querySelector('header,.header,#header'); if(hh){ var hr=hh.getBoundingClientRect(); if(hr.height>0&&hr.top<80) hb=hr.bottom; } var pb=p.getBoundingClientRect().bottom; var mh=Math.max(200,Math.min(520,Math.round(pb-hb-12))); p.style.setProperty('max-height',mh+'px','important'); }catch(_){} }
    document.addEventListener('keydown',function(e){ if(e.key==='Escape') shut(); });
    function jrhxMobile(){ try{ var narrow=window.innerWidth<=560, mob=window.innerWidth<=900; var hero=document.querySelector('#s-hero'); if(!hero) return; var set=function(el,p,val){ if(!el) return; if(val===null) el.style.removeProperty(p); else el.style.setProperty(p,val,'important'); }; set(hero.querySelector('.jrnh-l'),'transform', mob?'none':null); var tag=hero.querySelector('.jrnh-tag'); set(tag,'display', mob?'block':null); set(tag,'margin-bottom', mob?'22px':null); var b=hero.querySelector('.hero-search__btn'), sp=b&&b.querySelector('span'); set(b,'min-width', narrow?'0':null); set(b,'width', narrow?'auto':null); set(b,'padding', narrow?'0 9px':null); set(sp,'font-size', narrow?'10.5px':null); set(sp,'letter-spacing', narrow?'.02em':null); set(hero.querySelector('.hero-search__magnifier'),'display', narrow?'none':null); set(hero.querySelector('.hero-search__input'),'min-width', narrow?'30px':null); [].forEach.call(hero.querySelectorAll('.jrhx__t'),function(t){ set(t,'padding',narrow?'0 6px':null); set(t,'font-size',narrow?'11px':null); set(t,'gap',narrow?'4px':null); }); [].forEach.call(hero.querySelectorAll('.jrhx__sep'),function(s){ set(s,'margin',narrow?'0':null); }); }catch(_){} }
    window.addEventListener('resize',function(){ shut(); jrhxMobile(); });
    jrhxMobile(); setTimeout(jrhxMobile,600); setTimeout(jrhxMobile,1800); setTimeout(jrhxMobile,3200);
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',fill); else fill();
  setTimeout(fill,600); setTimeout(fill,1800);
})();
